import lodash from 'lodash';
import { initAuthenticationRx } from './authenticationRx';
import AuthenticationManager from './authenticationManager';

let authenticationManager = null;

const initAuthentication = (flex, FlexApiRequest = window.FlexApiRequest) => {
    const oauthConfig = lodash.get(flex.getStore(), ['appContext', 'oauth']);

    authenticationManager = new AuthenticationManager(
        oauthConfig.authorization_server_uri,
        oauthConfig.client_id,
        oauthConfig.redirect_uri
    );
    
    initAuthenticationRx(flex, authenticationManager, FlexApiRequest);
};

const getManager = () => {
    if (!authenticationManager) {
        throw new Error("Authentication manager is not initialized. Call initAuthentication first.");
    }

    return authenticationManager;
}

export {
    initAuthentication,
    getManager
};